var PersonsArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
export const PersonsVariant = PersonsArray.map(i => {
	return { name: i, value: i };
});

export const CitySizeVariant = [
	{
		value: '0',
		name: 'Praha',
	},
	{
		value: '1',
		name: 'více než 100000',
	},
	{
		value: '2',
		name: '50000 - 99999',
	},
	{
		value: '3',
		name: '10000 - 49999',
	},
	{
		value: '4',
		name: 'do 9999',
	},
];

export const ContractVariant = [
	{
		value: '0',
		name: 'nájemní',
	},
	{
		value: '1',
		name: 'osobní/družstevní',
	},
];
